import React from 'react';

export const ComingSoonCard = ({ title, description }) => (
  <div className="coming-soon-card">
    <div className="coming-soon-badge">Coming Soon</div>
    <h1 className="coming-soon-title">{title}</h1>
    <p className="coming-soon-desc">{description}</p>
  </div>
);
